import getRightPlaylistStyles from './rplaylist.css';
import getBottomPlaylistStyles from './bplaylist.css';

export default function getStyles(styles, rect) {

   const rightPlaylistCss = getRightPlaylistStyles(styles, rect);
   const bottomPlaylistCss = getBottomPlaylistStyles(styles, rect);

   return `

.rplayer__playlist-wrapper {
   background-color: #000;
}

.rplayer__playlist {
  color: ${styles.mainColor}
}

.rplayer__playlist-header {
   padding: 8px;
   margin: 0;
   font-size: 16px;
   line-height: 1.4;
   display: block;
   overflow: hidden;
   color: ${styles.mainColor};
   font-weight: 400;
}

.rplayer__playlist-current-title {
   display: none;
}

.rplayer__playlist-item {
   position: relative;
   cursor: pointer;
}

.rplayer__playlist-item-thumb {
   position: relative;
   overflow: hidden;
}

.rplayer__playlist-of {
   position: absolute;
   font-size: 12px;
   color: ${styles.mainColor};
}

.rplayer__playlist .rplayer__playlist-item:last-child {
   margin: 0 !important
}

.rplayer__playlist-item--current {
   cursor: inherit;
   background-color: #757575
}

.rplayer__playlist-item--current .rplayer__playlist-item-thumb:before {
   display: block;
   content: '►';
   position: absolute;
   top: 0;
   bottom: 0;
   left: 0;
   right: 0;
   text-align: center;
   z-index: 9;
   background-color: rgba(255,255,255,0.5);
   text-shadow: 0.125rem 0.125rem 0.5rem #333
}

.rplayer__playlist-item-thumb img {
   position: absolute;
   width: 100%
}


${rightPlaylistCss}

${bottomPlaylistCss}

   `;
}
